export default "__VITE_ASSET__329bf591__"